import React from 'react';

export const pageMeta = {
  "name": "JS Data Types",
  "link": "/javascript/data-types"
};

export default function JavascriptDataTypes() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Data Types</h2>
      <p>Route: /javascript/data-types</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
